"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _configUtils = require("AudienceTargetingUIComponents/utils/configUtils");

var FilterGenericSelect =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FilterGenericSelect, _PureComponent);
  (0, _createClass2.default)(FilterGenericSelect, null, [{
    key: "propTypes",
    get: function get() {
      return {
        onBlur: _react.PropTypes.func.isRequired,
        labelConfig: _react.PropTypes.object,
        onChange: _react.PropTypes.func.isRequired,
        value: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_immutable.List), _react.PropTypes.array, _react.PropTypes.string, _react.PropTypes.bool]),
        type: _react.PropTypes.string.isRequired,
        options: _react.PropTypes.object.isRequired,
        multi: _react.PropTypes.bool,
        size: _react.PropTypes.string
      };
    }
  }]);

  function FilterGenericSelect(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FilterGenericSelect);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FilterGenericSelect).call(this, props));
    _this.validateInput = _this.validateInput.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      isInputValid: true
    };
    return _this;
  }

  (0, _createClass2.default)(FilterGenericSelect, [{
    key: "validateInput",
    value: function validateInput(value) {
      var type = this.props.type;
      var size = value && value.size;
      if (value && value.length) size = value.length;
      var normalizedValue = type === 'contact' ? value !== undefined : Boolean(size);
      this.setState({
        isInputValid: normalizedValue
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.props.onBlur();
      this.validateInput(this.props.value);
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var value = e.target.value;
      this.props.onChange(e);
      this.validateInput(value);
    }
  }, {
    key: "getLangKey",
    value: function getLangKey(suffix) {
      return "AudienceTargeting." + suffix;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          labelConfig = _this$props.labelConfig,
          value = _this$props.value,
          options = _this$props.options,
          type = _this$props.type,
          multi = _this$props.multi,
          size = _this$props.size;
      var className = "targeting-option__input " + size;
      var selectValue = value instanceof _immutable.List ? value.toJS() : value;

      var placeholder = labelConfig.select || _I18n.default.text(this.getLangKey('select'));

      return _react.default.createElement(_UIFormControl.default, {
        className: className
      }, _react.default.createElement(_UISelect.default, {
        error: !this.state.isInputValid,
        multi: multi || false,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        options: Object.keys(options).map(function (option) {
          var custom;

          if (labelConfig[type]) {
            custom = (0, _configUtils.searchConfig)(labelConfig, [type, option]);
          }

          return {
            text: custom || _I18n.default.text(_this2.getLangKey(type + "." + option)),
            value: options[option]
          };
        }),
        value: selectValue,
        placeholder: placeholder
      }));
    }
  }]);
  return FilterGenericSelect;
}(_react.PureComponent);

exports.default = FilterGenericSelect;
module.exports = exports.default;